import { apiRequest } from '@/api/client';
import type { AssetDownloadUrl, AssetPack } from '@/types';

export interface AssetsQuery {
  category?: string;
  gameId?: string;
  limit?: number;
}

export async function fetchAssets(
  accessToken: string,
  query: AssetsQuery = {},
  sessionId?: string | null,
): Promise<AssetPack[]> {
  const params = new URLSearchParams();
  if (query.category) params.set('category', query.category);
  if (query.gameId) params.set('gameId', query.gameId);
  if (query.limit) params.set('limit', String(query.limit));

  const qs = params.toString();
  const data = await apiRequest<{ assets?: AssetPack[]; items?: AssetPack[] }>(
    `/assets${qs ? `?${qs}` : ''}`,
    { accessToken, sessionId },
  );
  return data.assets ?? data.items ?? (Array.isArray(data) ? data : []);
}

export async function fetchAssetDownloadUrl(
  id: string,
  accessToken: string,
  category?: string,
  sessionId?: string | null,
): Promise<AssetDownloadUrl> {
  const qs = category ? `?category=${encodeURIComponent(category)}` : '';
  return apiRequest<AssetDownloadUrl>(
    `/assets/${encodeURIComponent(id)}/download-url${qs}`,
    { accessToken, sessionId },
  );
}
